import { mapToSelect } from "@api/egm";
import { UIDateFormat } from "@helpers/dates";
import DateTimeSelect from "@shared/DateTimeSelect";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { Button, Checkbox, Form, Dropdown, Select } from "semantic-ui-react";

const KioskFilters = (props) => {
  const {
    fromDate,
    currentDate,
    toDate,
    loading,
    includeEvents,
    collectionDate,
    useCollectionWeek,
  } = props.data.filters;
  const { positions } = props.data;
  const { collectionDates } = positions;

  const { disabled, handleChange } = props;

  const handleDateChange = (event, { name, value }) => {
    const date = moment(value, UIDateFormat);
    date.set({
      hour: props.data.filters[name].get("hour"),
      minute: props.data.filters[name].get("minute"),
      second: props.data.filters[name].get("second"),
    });

    handleChange({ [name]: date });
  };

  const handleTimeChange = (event, { name, value }) => {
    const date = props.data.filters[name];
    const time = moment(
      `${date.format(UIDateFormat)} ${value}`,
      `${UIDateFormat} HH:mm:ss`,
    );
    handleChange({ [name]: time });
  };

  const handleCheckboxChange = (event, { name }) =>
    handleChange({ [name]: !props.data.filters[name] });

  const handleCurrentDateChange = () => {
    const toDate = moment();
    handleChange({ toDate, currentDate: !currentDate });
  };

  const options = [
    {
      key: "Date Period",
      text: "Date Period",
      value: 0,
    },
  ];

  if (collectionDates.length > 0) {
    options.push({
      key: "Collection Week",
      text: "Collection Week",
      value: 1,
    });

    options.push({
      key: "Current Week",
      text: "Current Week",
      value: 2,
    });
  }

  return (
    <Form>
      <Form.Group inline className="p-0 mb-0">
        <Form.Field>
          <Dropdown
            name="useCollectionWeek"
            options={options}
            search
            value={useCollectionWeek}
            onChange={(e, { name, value }) => handleChange({ [name]: value })}
          />
        </Form.Field>

        {useCollectionWeek === 1 && (
          <Form.Field>
            <Select
              name="collectionDate"
              value={collectionDate}
              onChange={(e, { name, value }) => handleChange({ [name]: value })}
              options={mapToSelect(collectionDates)}
            />
          </Form.Field>
        )}

        {useCollectionWeek === 0 && (
          <>
            <DateTimeSelect
              label="From:"
              name="fromDate"
              value={fromDate}
              handleDateChange={handleDateChange}
              handleTimeChange={handleTimeChange}
            />
            <DateTimeSelect
              label="To:"
              name="toDate"
              value={toDate}
              disabled={currentDate}
              handleDateChange={handleDateChange}
              handleTimeChange={handleTimeChange}
            />
            <Form.Field>
              <Checkbox
                name="currentDate"
                label="Current Date/Time"
                checked={currentDate}
                onChange={handleCurrentDateChange}
              />
            </Form.Field>
          </>
        )}

        <Form.Field>
          <Checkbox
            name="includeEvents"
            checked={includeEvents}
            onChange={handleCheckboxChange}
            label="Show Events"
          />
        </Form.Field>

        <Button
          disabled={loading || disabled}
          onClick={props.onRefresh}
          positive
          compact
          content="Refresh"
        />
      </Form.Group>
    </Form>
  );
};
const mapStateToProps = (state) => {
  return {
    filters: state.kioskFilters,
    data: state.kiosk,
  };
};
export default connect(mapStateToProps)(KioskFilters);
